var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"popup_spinner"}},[_c('div',[_vm._m(0),_c('div',[_c('b-spinner',{staticStyle:{"width":"8rem","height":"8rem"},attrs:{"variant":"info"}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('strong',[_c('span',{staticClass:"text-info",staticStyle:{"font-size":"20px"}},[_vm._v("處理中...")])])])
}]

export { render, staticRenderFns }